import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

import Image from '@components/Image'
import { H2, H6, Body1 } from '@components/Text'

export const Wrapper = styled.section`
  padding-top: 56px;
  padding-bottom: 32px;
  background-color: var(--white);

  @media (min-width: ${getBreakpoint('xl')}px) {
    padding-bottom: 96px;
  }
`

export const DividerWrapper = styled.section`
  margin-top: 24px;
  margin-bottom: 24px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 40px;
    margin-bottom: 40px;
  }
`

export const Header = styled(H2)`
  display: flex;
  flex-direction: column;
  line-height: 48px;
  font-weight: 900;
  color: var(--sao-paulo-60);
  margin-bottom: 16px;

  span {
    color: var(--primary-text);

    &:first-of-type {
      font-size: 20px;
      line-height: 28px;
      font-weight: 400;
    }

    &:last-of-type {
      font-size: 18px;
      line-height: 21px;
      font-weight: 700;
    }
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-botton: 0;
  }
`

export const PartnerIcon = styled(Image)`
  margin-top: 16px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 0;
  }
`

export const PartnerWrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  margin-bottom: 8px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 30px;
  }
`

export const PartnerTitle = styled(H6)`
  color: var(--primary-color);
`

export const PartnerDescription = styled(Body1)`
  margin-top: 8px;
  line-height: 20px;
  color: var(--secondary-color);
`
